// TODO: This will be replaced by Axios interceptors and retired.
import { FailureResponseData } from "@/models/FailureResponseData";

export class ErrorHandlingHelpers {
  public static getFailureMessage(error: any) {
    if (error.response.data.hasOwnProperty("ErrorMessage")) {
      return error.response.data;
    } else {
      return new FailureResponseData(error.message);
    }
  }
}
